import React from "react";

import '../../assets/styles/GroupTitle.css';

const GroupTitle = ({ question }) => {
    return <div key={question.sym_id} className="chat-message GroupTitle">
                <h4 dangerouslySetInnerHTML={{ __html: question.label }} className="m-0" />
                {question.sublabel && <p dangerouslySetInnerHTML={{ __html: question.sublabel }} className="mb-0 mt-2" />}
            </div>;
};

export default GroupTitle;
